import Vue from 'vue'
import VueI18n from 'vue-i18n'
import nknStorage from '@/assets/js/nknStorage'

Vue.use(VueI18n)

let lang = ''
let params = location.pathname.replace(/\/([^\/]*)\/?.*/, '$1')
if (params === 'en' || params === 'zh' || params === 'kr') {
  lang = params
} else {
  if (typeof navigator !== 'undefined') {
    let navLang = navigator.language || navigator.userLanguage
    if (!!navLang) lang = navLang.substr(0, 2)
  }
}

if (!lang) {
  // nknStorage.setLang('en')
  lang = 'en'
}

const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'en',
  messages: {
    'en': require('@/i18n/en'),
    'zh': require('@/i18n/zh'),
    'kr': require('@/i18n/kr')
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js